<mat-form-field
  class="w-full text-project-50"
  [ngClass]="{ 'on-error': control.hasError('required') }"
  [appearance]="'outline'"
>
  <input
    type="text"
    matInput
    [name]="name"
    [formControl]="control"
    [placeholder]="placeholder"
    [maxlength]="maxLength"
    [ngClass]="{
      'font-bold': boldFont,
      'font-normal': !boldFont
    }"
    class="text-project-1400"
  />
</mat-form-field>
